import styles from './index.module.scss'
import { FaDiscord, FaQuestionCircle } from 'react-icons/fa'
import { motion } from "framer-motion"
import { Spinner } from '../../components/misc/Spinner';
import { useAuth } from "../../utils/hooks/useAuth";
import { MoonLoader } from 'react-spinners';
import { useNavigate } from "react-router-dom";

const Login = () => {
  const naviage = useNavigate()

  const handleLogin = () => {
    window.location.href = 'https://api-dreamvast.onrender.com/api/auth/discord'
  }

  const supportServer = () => {
    window.location.href = 'https://discord.gg/uxbwPDtYq8'
  }
  const { auth, error, loading } = useAuth()

  if (loading) return <Spinner children={<MoonLoader size={40} color="white" />} />;

  if (!error && auth === 200) naviage('/menu')

  return (
    <div>
      <head>
        <title>Login</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </head>
      <div className={styles.loginpage}>
        <div>
          <button className={styles.button} onClick={handleLogin}>
            <FaDiscord size={45} color="#7289DA"/>
            <span>Login with Discord</span>
          </button>
          
          <button className={styles.button} onClick={supportServer}>
            <FaQuestionCircle size={45} color="#ffffff"/>
            <span>Support Server</span>
          </button>
        </div>

        <motion.div
        initial={{ opacity: 0, y: -5 }}  
        whileInView={{ opacity: 1, y: 5 }}
        transition={{ duration: 0.5 }}
        className={styles.footer}>
          <span><a href={'/docs/policy'}>Privacy Policy</a></span>
          <span><a href={'/docs/terms'} >Terms of Service</a></span>
          <span><a href={'https://discord.gg/uxbwPDtYq8'}>Contact Us</a></span>
        </motion.div>
      </div>
    </div>
  )
}

export default Login
